import { buildValidations, validator } from 'ember-cp-validations';
import { empty } from '@ember/object/computed';
export default buildValidations({
  steps: {
    description: 'Steps',
    validators: [validator('presence', true)]
  },
  pointerSteps: {
    validators: [validator('all-pointers-have-selectors')],
    message: 'Your tour doesn’t contain any content. Add pointers or posts to show in your tour.'
  },
  url: validator('presence', {
    presence: true,
    description: 'Url',
    message: 'Choose a URL for your tour to appear on.',
    disabled: empty('model.steps')
  })
});